{
	"migratingProjectStyle": "Migrating project AI Style..."
}
